<template>
  <div class="template" :class="{ 'template--selected': isSelected }">
    <div class="template__ok_icon">
      <svg-icon type="checkmark" />
    </div>
    <img
      class="template__cover"
      :src="data.cover.startsWith('/') ? data.cover : `/${data.cover}`"
      :alt="data.display_name"
    />
    <p class="template__description">
      <span class="template__name template__name--black">{{
        data.display_name
      }}</span>
      {{ data.description }}
    </p>
    <div class="template__buttons" v-if="!isMobile">
      <button class="template__btn template__btn--blue" @click="chooseTemplate">
        Выбрать
      </button>
      <button
        class="template__btn template__btn--transparent"
        @click="openPreview"
      >
        <svg-icon classNames="left" type="eye-gray" />
        Предпросмотр
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "TemplateCard",
  props: ["data"],
  mounted() {},
  data() {
    return {
      isMobile: window.innerWidth < 768,
      isWhite: false
    };
  },
  computed: {
    isSelected() {
      return this.data.id === this.$store.state.page.template.id;
    }
  },
  methods: {
    chooseTemplate() {
      this.$emit("template-choosed", this.data.id);
      this.GAEvent("step_2-theme_click", "template_id", this.data.name);
    },
    openPreview() {
      this.GAEvent("step_2-preview_click", "template_id", this.data.name);
      window.open(
        `${window.location.protocol}//${window.location.host}/preview/${this.data.preview_id}`
      );
    },
    calcBrightness(e) {
      let colorSum = 0;
      let canvas = document.createElement("canvas");
      canvas.width = e.target.width;
      canvas.height = e.target.height;

      let ctx = canvas.getContext("2d");
      ctx.drawImage(e.target, 0, 0);

      let imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
      let data = imageData.data;
      let r, g, b, avg;

      for (let x = 0, len = data.length; x < len; x += 4) {
        r = data[x];
        g = data[x + 1];
        b = data[x + 2];

        avg = Math.floor((r + g + b) / 3);
        colorSum += avg;
      }

      let brightness = Math.floor(
        colorSum / (e.target.width * e.target.height)
      );
      this.isWhite = brightness > 165;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/vars";
.template {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-radius: 12px 12px 0 0;
  flex-basis: calc((100% / 3) - 20px);
  position: relative;
  margin: 0 15px 60px;
  &:nth-child(3n + 1) {
    margin-left: 0;
  }
  &:nth-child(3n) {
    margin-right: 0;
  }
  @media (max-width: 1024px) {
    flex-basis: calc(50% - 20px);
    margin: 0 15px 60px !important;
    &:nth-child(2n + 1) {
      margin-left: 0 !important;
    }
    &:nth-child(2n) {
      margin-right: 0 !important;
    }
  }
  @media #{$mobile} {
    flex-basis: initial;
    margin: 0 0 60px !important;
  }
  &__ok_icon {
    justify-content: center;
    align-items: center;
    background: #26cc72;
    width: 72px;
    height: 72px;
    border-radius: 100%;
    position: absolute;
    top: 44px;
    left: calc(50% - 36px);
    display: none;
    z-index: 1;
    .template--selected & {
      display: flex;
    }
  }
  &__name {
    display: block;
    font-size: 24px;
    font-family: Inter, sans-serif;
    font-weight: 600;
    margin-bottom: 15px;
    &--white {
      color: #ffffff;
    }
    &--black {
      color: #000000;
    }
    @media #{$mobile} {
    }
  }
  &__cover {
    height: 160px;
    object-fit: cover;
    .template--selected & {
      opacity: 0.5;
    }
  }
  &__description {
    margin: 0;
    padding: 25px;
    border-left: 1px solid #e0e0e0;
    border-right: 1px solid #e0e0e0;
    height: 160px;
    @media #{$mobile} {
      border-bottom: 1px solid #e0e0e0;
      border-radius: 0 0 12px 12px;
      padding: 15px;
      height: 140px;
    }
  }

  &__buttons {
    display: flex;
    border-radius: 0 0 12px 12px;
    overflow: hidden;
  }

  &__btn {
    font-family: Inter, sans-serif;
    font-size: 15px;
    padding: 17px 0;
    text-transform: uppercase;
    font-weight: bold;
    display: flex;
    align-content: center;
    align-items: center;
    justify-content: center;
    outline: none;
    cursor: pointer;
    &--blue {
      color: #ffffff;
      background: #3b60ec;
      border: none;
      flex-basis: 40%;
    }
    &--transparent {
      background: transparent;
      color: #808080;
      flex-basis: 60%;
      border-left: none;
      border-top: 1px solid #e0e0e0;
      border-bottom: 1px solid #e0e0e0;
      border-right: 1px solid #e0e0e0;
      border-bottom-right-radius: 12px;
      span {
        display: flex;
      }
    }
  }
}
</style>
